/* =============================================
   PETDOGCENTRAL SHOP — EXTRACTED INLINE SCRIPTS
   ============================================= */


/* --- Sticky Bar: show after scrolling past hero --- */
(function() {
  var hero = document.getElementById('hero');
  var sticky = document.getElementById('stickyBar');
  if (!hero || !sticky) return;
  if (!('IntersectionObserver' in window)) {
    sticky.classList.remove('visible');
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        sticky.classList.remove('visible');
      } else {
        sticky.classList.add('visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(hero);
})();

/* --- Coupon Countdown Timer --- */
var gsCouponEl = document.getElementById('gsCouponTimer');
if (gsCouponEl) {
  var gsCouponSecs = 599;
  setInterval(function() {
    if (gsCouponSecs <= 0) gsCouponSecs = 599;
    gsCouponSecs--;
    var m = Math.floor(gsCouponSecs / 60);
    var s = gsCouponSecs % 60;
    gsCouponEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }, 1000);
}

/* --- FAQ Accordion --- */
function toggleFaq(el) {
  var item = el.closest('.gs-faq-item');
  var answer = item.querySelector('.gs-faq-answer');
  var isActive = item.classList.contains('active');

  // Close all
  document.querySelectorAll('.gs-faq-item.active').forEach(function(openItem) {
    openItem.classList.remove('active');
    openItem.querySelector('.gs-faq-answer').style.maxHeight = null;
  });

  // Open clicked (if it wasn't already open)
  if (!isActive) {
    item.classList.add('active');
    answer.style.maxHeight = answer.scrollHeight + 'px';
  }
}

/* --- Smooth scroll for anchor links --- */
document.querySelectorAll('a[href^="#"]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// Smooth scroll for promo bar CTA
document.querySelectorAll('a[href="#offercard"]').forEach(function(a) {
  a.addEventListener('click', function(e) {
    e.preventDefault();
    var target = document.getElementById('heroOffer');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

/* --- Responsive image hints for below-fold media --- */
(function() {
  var timelineImg = document.querySelector('.gs-timeline-img img');
  if (!timelineImg) return;
  timelineImg.decoding = 'async';
  timelineImg.sizes = '(max-width: 767px) calc(100vw - 40px), 550px';
})();

// Hero offer card bundle selection
(function() {
  var urls = { '423': 'https://checkout.petdogcentral.com/?products=423:1&cc_custom_offer_position=top', '427': 'https://checkout.petdogcentral.com/?products=427:1&cc_custom_offer_position=top', '425': 'https://checkout.petdogcentral.com/?products=425:1&cc_custom_offer_position=top' };
  var prices = { '423': '$29.99', '427': '$59.99', '425': '$89.99' };
  var options = document.querySelectorAll('.gs-hero-bundle-option');
  var ctaBtn = document.getElementById('heroCta');
  var ctaPrice = document.getElementById('heroCtaPrice');
  options.forEach(function(opt) {
    opt.addEventListener('click', function() {
      options.forEach(function(o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
      opt.querySelector('input').checked = true;
      var pid = opt.getAttribute('data-product');
      if (ctaBtn && urls[pid]) ctaBtn.href = urls[pid];
      if (ctaPrice && prices[pid]) ctaPrice.textContent = prices[pid];
    });
  });
})();

/* ATC click handler is now registered in the head of index.html as a pointerdown delegator on document (capture phase), matching #heroCta and .gs-bundle-cta. See <head> for the implementation. */

/* --- Geo-dynamic content swaps --- */
(function() {
  var city = window.__geoCity;
  var region = window.__geoRegion;
  var cc = window.__geoCC || 'US';

  // US state code → full name (Cloudflare sends codes for US, full names for others)
  var usStateNames = {
    'AL':'Alabama','AK':'Alaska','AZ':'Arizona','AR':'Arkansas','CA':'California',
    'CO':'Colorado','CT':'Connecticut','DE':'Delaware','FL':'Florida','GA':'Georgia',
    'HI':'Hawaii','ID':'Idaho','IL':'Illinois','IN':'Indiana','IA':'Iowa',
    'KS':'Kansas','KY':'Kentucky','LA':'Louisiana','ME':'Maine','MD':'Maryland',
    'MA':'Massachusetts','MI':'Michigan','MN':'Minnesota','MS':'Mississippi','MO':'Missouri',
    'MT':'Montana','NE':'Nebraska','NV':'Nevada','NH':'New Hampshire','NJ':'New Jersey',
    'NM':'New Mexico','NY':'New York','NC':'North Carolina','ND':'North Dakota','OH':'Ohio',
    'OK':'Oklahoma','OR':'Oregon','PA':'Pennsylvania','RI':'Rhode Island','SC':'South Carolina',
    'SD':'South Dakota','TN':'Tennessee','TX':'Texas','UT':'Utah','VT':'Vermont',
    'VA':'Virginia','WA':'Washington','WI':'Wisconsin','WV':'West Virginia','WY':'Wyoming',
    'DC':'Washington DC'
  };

  // Resolve region name: US gets state name from code, everyone else gets region as-is from Cloudflare
  var regionName = (cc === 'US') ? (usStateNames[region] || region) : (region || '');

  // Mixed US + UK testimonial cities (shown to ALL visitors)
  var testimonialPool = [
    'Austin, TX', 'San Diego, CA', 'Orlando, FL',
    'London, UK', 'Manchester, UK', 'Bristol, UK'
  ];

  // --- Orders today (rolling count based on hour) ---
  var hour = new Date().getHours();
  var ordersBase = Math.floor(hour * 3.2) + 7;
  var ordersToday = ordersBase + Math.floor(Math.random() * 5);
  document.querySelectorAll('.geo-orders-today').forEach(function(el) {
    el.textContent = ordersToday;
  });

  // --- Ship date (tomorrow's date) ---
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var now = new Date();
  now.setDate(now.getDate() + 1);
  var shipDate = months[now.getMonth()] + ' ' + now.getDate();
  document.querySelectorAll('.geo-ship-date').forEach(function(el) {
    el.textContent = shipDate;
  });

  // --- City swaps (ALL visitors) ---
  if (city) {
    document.querySelectorAll('.geo-city').forEach(function(el) {
      el.textContent = city.toUpperCase();
    });
    document.querySelectorAll('.geo-city-ship, .geo-faq-city').forEach(function(el) {
      el.textContent = city;
    });
    document.querySelectorAll('.geo-city-bundle, .geo-city-bundle-top').forEach(function(el) {
      el.textContent = city;
    });
  }

  // --- Region swaps (ALL visitors) ---
  if (regionName) {
    document.querySelectorAll('.geo-state-cost').forEach(function(el) {
      el.textContent = 'in ' + regionName;
    });
    document.querySelectorAll('.geo-state-comparison').forEach(function(el) {
      el.textContent = 'avg. in ' + regionName;
    });
    document.querySelectorAll('.geo-state-comparison-m').forEach(function(el) {
      el.textContent = 'avg. in ' + regionName;
    });
    document.querySelectorAll('.geo-final-state').forEach(function(el) {
      el.textContent = regionName;
    });

    // Pseudo-local count
    var count = Math.floor(Math.random() * 60) + 40;
    if (cc === 'US') {
      var bigStates = ['CA','TX','FL','NY','PA','IL','OH','GA','NC','MI'];
      var midStates = ['NJ','VA','WA','AZ','MA','TN','IN','MO','MD','WI','CO','MN','SC','AL','LA','KY','OR','OK','CT','IA'];
      if (bigStates.indexOf(region) !== -1) {
        count = Math.floor(Math.random() * 80) + 120;
      } else if (midStates.indexOf(region) !== -1) {
        count = Math.floor(Math.random() * 40) + 50;
      } else {
        count = Math.floor(Math.random() * 20) + 20;
      }
    }
    document.querySelectorAll('.geo-final-count').forEach(function(el) {
      el.textContent = count + '+';
    });
  }

  // --- Testimonial locations ---
  var usCities = {
    'CA':['Sacramento','San Diego','Fresno','Irvine','Pasadena','Santa Rosa'],
    'TX':['Austin','Dallas','San Antonio','Houston','Fort Worth','Plano'],
    'FL':['Tampa','Orlando','Jacksonville','Boca Raton','Naples','Sarasota'],
    'NY':['Albany','Buffalo','Rochester','Yonkers','Syracuse','White Plains'],
    'PA':['Pittsburgh','Allentown','Lancaster','Reading','Scranton','Bethlehem'],
    'OH':['Columbus','Cincinnati','Cleveland','Dayton','Toledo','Akron'],
    'IL':['Springfield','Naperville','Peoria','Evanston','Arlington Heights','Schaumburg'],
    'GA':['Savannah','Augusta','Athens','Marietta','Roswell','Alpharetta'],
    'NC':['Raleigh','Charlotte','Durham','Greensboro','Asheville','Cary'],
    'MI':['Grand Rapids','Ann Arbor','Lansing','Kalamazoo','Troy','Sterling Heights'],
    'NJ':['Princeton','Hoboken','Cherry Hill','Morristown','Edison','Montclair'],
    'VA':['Richmond','Virginia Beach','Arlington','Alexandria','Norfolk','Roanoke'],
    'WA':['Tacoma','Bellevue','Spokane','Kirkland','Redmond','Olympia'],
    'AZ':['Scottsdale','Tucson','Mesa','Tempe','Chandler','Gilbert'],
    'MA':['Cambridge','Worcester','Salem','Newton','Brookline','Plymouth'],
    'CO':['Boulder','Colorado Springs','Fort Collins','Aurora','Lakewood','Arvada'],
    'MN':['St. Paul','Rochester','Duluth','Bloomington','Plymouth','Edina'],
    'TN':['Nashville','Memphis','Knoxville','Chattanooga','Franklin','Murfreesboro'],
    'MO':['Kansas City','St. Louis','Springfield','Columbia','Independence','Lee\u2019s Summit'],
    'OR':['Eugene','Salem','Bend','Beaverton','Lake Oswego','Hillsboro']
  };
  var usDefault = ['Springfield','Madison','Georgetown','Fairview','Franklin','Clinton'];
  var ukCities = ['London','Manchester','Bristol','Birmingham','Leeds','Edinburgh'];

  if (cc === 'US') {
    var pool = usCities[region] || usDefault;
    document.querySelectorAll('.geo-testimonial-loc').forEach(function(el, i) {
      el.textContent = '\u2014 ' + pool[i % pool.length] + (region ? ', ' + region : '');
      el.style.fontSize = '14px';
      el.style.color = '#6B7A8D';
      el.style.fontWeight = '400';
    });
  } else if (cc === 'GB') {
    document.querySelectorAll('.geo-testimonial-loc').forEach(function(el, i) {
      el.textContent = '\u2014 ' + ukCities[i % ukCities.length] + ', UK';
      el.style.fontSize = '14px';
      el.style.color = '#6B7A8D';
      el.style.fontWeight = '400';
    });
  }

})();

/* --- ViewContent event (delay third-party work until after load) --- */
(function() {
  window.addEventListener('load', function() {
    function gC(n){var m=document.cookie.match(new RegExp('(?:^|;\\s*)'+n+'=([^;]*)'));return m?m[1]:'';}
    var fbp=gC('_fbp'),fbc=gC('_fbc'),extId=gC('_external_id');
    if(!fbc){var m=window.location.search.match(/[?&]fbclid=([^&]*)/);if(m)fbc='fb.1.'+Date.now()+'.'+m[1];}
    var dataLayer=window.dataLayer=window.dataLayer||[],vcFired=false,isMetaBot=/facebookexternalhit|meta-external|Facebot|facebookcatalog/i.test(navigator.userAgent);
    window._pageStart=window._pageStart||Date.now();
    function fireVC(){if(vcFired||(!isMetaBot&&(document.hidden||Date.now()-window._pageStart<1500)))return;vcFired=true;var p={event:'view_content'};if(fbc)p.fbc=fbc;if(fbp)p.fbp=fbp;if(extId)p.external_id=extId;dataLayer.push(p);}
    setTimeout(fireVC,1500);
    document.addEventListener('visibilitychange', function(){if(!document.hidden)fireVC();});
  });
})();

/* --- Vet Testimonials Slider Arrows --- */
(function() {
  var track = document.querySelector('.gs-vet-testimonials-grid');
  if (!track) return;
  var prev = document.querySelector('.gs-vet-arr.prev');
  var next = document.querySelector('.gs-vet-arr.next');
  if (!prev || !next) return;
  var card = track.querySelector('.gs-vet-card');
  if (!card) return;
  prev.onclick = function() {
    var w = card.offsetWidth + 16;
    track.scrollBy({ left: -w, behavior: 'smooth' });
  };
  next.onclick = function() {
    var w = card.offsetWidth + 16;
    track.scrollBy({ left: w, behavior: 'smooth' });
  };
})();

/* --- Comparison Slider Arrows --- */
(function() {
  var track = document.querySelector('.gs-compare-cards');
  if (!track) return;
  var prev = document.querySelector('.gs-compare-arr.prev');
  var next = document.querySelector('.gs-compare-arr.next');
  if (!prev || !next) return;
  var card = track.querySelector('.gs-compare-card');
  if (!card) return;
  prev.onclick = function() {
    var w = card.offsetWidth + 16;
    track.scrollBy({ left: -w, behavior: 'smooth' });
  };
  next.onclick = function() {
    var w = card.offsetWidth + 16;
    track.scrollBy({ left: w, behavior: 'smooth' });
  };
})();

/* --- Hidden Reviews: warm images before reveal --- */
(function() {
  var reviewsSection = document.getElementById('reviews');
  if (!reviewsSection) return;
  var reviewImageCache = [];
  var warmedAll = false;

  function warmHiddenReviewImages(limit) {
    var warmedThisPass = 0;
    reviewsSection.querySelectorAll('.gs-review-hidden img[data-src]').forEach(function(img) {
      if (limit && warmedThisPass >= limit) return;
      if (img.dataset.preloaded === 'true') return;
      var src = img.getAttribute('data-src');
      if (!src) return;
      var preload = new Image();
      preload.src = src;
      img.dataset.preloaded = 'true';
      reviewImageCache.push(preload);
      warmedThisPass++;
    });
    return warmedThisPass;
  }

  function warmAllRemainingReviewImages() {
    if (warmedAll) return;
    warmHiddenReviewImages();
    warmedAll = true;
  }

  window.revealMoreReviews = function(button) {
    warmAllRemainingReviewImages();
    var hidden = reviewsSection.querySelectorAll('.gs-review-hidden');
    var count = 0;
    hidden.forEach(function(card) {
      if (count >= 4) return;
      card.classList.remove('gs-review-hidden');
      card.querySelectorAll('img[data-src]').forEach(function(img) {
        var src = img.getAttribute('data-src');
        if (!src) return;
        img.src = src;
        img.removeAttribute('data-src');
      });
      count++;
    });
    if (!reviewsSection.querySelector('.gs-review-hidden') && button && button.parentElement) {
      button.parentElement.style.display = 'none';
    }
  };

  window.addEventListener('load', function() {
    setTimeout(function() {
      warmHiddenReviewImages(4);
      if ('requestIdleCallback' in window) {
        requestIdleCallback(warmAllRemainingReviewImages, { timeout: 3000 });
      } else {
        setTimeout(warmAllRemainingReviewImages, 2000);
      }
    }, 300);
  }, { once: true });

  if ('IntersectionObserver' in window) {
    var reviewObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        warmAllRemainingReviewImages();
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '500px 0px' });
    reviewObserver.observe(reviewsSection);
  }
})();

/* --- Steps Slider Arrows + Lazy Video --- */
(function() {
  var track = document.querySelector('.gs-steps');
  if (!track) return;
  var prev = document.querySelector('.gs-steps-arr.prev');
  var next = document.querySelector('.gs-steps-arr.next');
  var card = track.querySelector('.gs-step-card');
  if (prev && next && card) {
    prev.onclick = function() {
      var w = card.offsetWidth + 16;
      track.scrollBy({ left: -w, behavior: 'smooth' });
    };
    next.onclick = function() {
      var w = card.offsetWidth + 16;
      track.scrollBy({ left: w, behavior: 'smooth' });
    };
  }
  function hydrateVideo(video) {
    if (video.dataset.hydrated === 'true') return;
    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) {
      video.dataset.hydrated = 'true';
      return;
    }
    sources.forEach(function(source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    });
    video.dataset.hydrated = 'true';
    video.load();
  }

  var videos = track.querySelectorAll('video');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          hydrateVideo(video);
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function() {});
          }
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.35 });
    videos.forEach(function(video) { obs.observe(video); });
  } else {
    videos.forEach(function(video) {
      hydrateVideo(video);
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {});
      }
    });
  }
})();

